"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInfoBlockTitleProperty = exports.infoBlockTitlePropertyDefinition = void 0;
exports.infoBlockTitlePropertyDefinition = {
    view: {
        label: 'Section Title',
        hint: 'The title of an info block. Example: Sign up or Playstation 5',
        style: 'h3',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'maxLength',
            argument: 72,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'info-block-title',
};
const isInfoBlockTitleProperty = (prop) => {
    return prop.name === exports.infoBlockTitlePropertyDefinition.name;
};
exports.isInfoBlockTitleProperty = isInfoBlockTitleProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5mby1ibG9jay10aXRsZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2luZm8tYmxvY2stdGl0bGUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxnQ0FBZ0MsR0FBRztJQUM5QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsZUFBZTtRQUN0QixJQUFJLEVBQUUsK0RBQStEO1FBQ3JFLEtBQUssRUFBRSxJQUFJO0tBQ1o7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxFQUFFO1NBQ2I7S0FDRjtJQUNELElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsa0JBQWtCO0NBQ08sQ0FBQTtBQUkxQixNQUFNLHdCQUF3QixHQUFHLENBQUMsSUFBa0IsRUFBa0MsRUFBRTtJQUM3RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssd0NBQWdDLENBQUMsSUFBSSxDQUFBO0FBQzVELENBQUMsQ0FBQTtBQUZZLFFBQUEsd0JBQXdCLDRCQUVwQyJ9